// extracted by mini-css-extract-plugin
export default {"header":"style_header__Cvtvs","something":"style_something__8iBPo"};